import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import { consentsTypes } from '@/components/services/registration/consents'

function renderCheckbox(h, type) {
  return h(
    'div',
    {
      class: `${Services.registration}-form__consents-checkbox`,
      on: {
        click: () => {
          this.consents[type] = !this.consents[type]
        }
      }
    },
    [
      h(
        components.checkbox,
        {
          props: {
            value: this.consents[type]
          }
        }
      )
    ]
  )
}
function renderLabel(h, type) {
  return h(
    'div',
    {
      class: `${Services.registration}-form__consents-label`,
      domProps: {
        innerHTML: this.labels[type]
      }
    }
  )
}
function renderItem(h, type) {
  return h(
    'div',
    {
      class: `${Services.registration}-form__consents-item`
    },
    [
      renderCheckbox.call(this, h, type),
      renderLabel.call(this, h, type)
    ]
  )
}

function renderItems(h) {
  return consentsTypes.map(type => {
    return renderItem.call(this, h, type)
  })
}

export default function(h) {
  if (this.isConsentsRequired) {
    return h(
      'div',
      {
        class: `${Services.registration}-form__consents`
      },
      [ renderItems.call(this, h) ]
    )
  }
}
